export default __webpack_public_path__ + "static/media/carousel.89d8610e.svg";